import { CalendarIcon } from "lucide-react";
import * as React from "react";

import { TimePickerInput } from "./ time-picker-input";
import { TimePeriodSelect } from "./period-select";
import { Period } from "./time-picker-utils";

import { cn } from "@/lib/utils";
import Icons from "@/utils/Icons";
import { dateToSec } from "@/utils/helper-functions/date-time.helper";

interface TimePickerDemoProps {
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
  limit?: Date | undefined;
  disabled?: boolean;
  AMPM?: Period;
  setAMPM?: React.Dispatch<React.SetStateAction<Period>>;
  showIcon?: boolean;
  className?: string;
}

export const TimePicker12: React.FC<TimePickerDemoProps> = ({
  date,
  setDate,
  limit,
  disabled,
  AMPM,
  setAMPM,
  showIcon = false,
  className,
}) => {
  const [period, setPeriod] = React.useState<Period>(AMPM || "AM");
  const minuteRef = React.useRef<HTMLInputElement>(null);
  const hourRef = React.useRef<HTMLInputElement>(null);
  const periodRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    if (setAMPM) {
      setAMPM(dateToSec(date) > 43199 ? "PM" : "AM");
    }
  }, [period]);

  return (
    <div
      className={cn(
        className,
        "flex items-center border rounded-md  bg-white dark:bg-inherit",
      )}
    >
      <div className='grid text-center'>
        <TimePickerInput
          picker='12hours'
          period={period}
          date={date}
          setDate={setDate}
          ref={hourRef}
          onRightFocus={() => minuteRef.current?.focus()}
          className='border-0'
          disabled={disabled}
          limit={limit}

          // defaultValue={newDateObject?.getHours()}
        />
      </div>
      <Icons name='colon-icon' size={15} />
      <div className='grid text-center'>
        <TimePickerInput
          picker='minutes'
          id='minutes12'
          date={date}
          setDate={setDate}
          ref={minuteRef}
          onLeftFocus={() => hourRef.current?.focus()}
          className='border-0'
          disabled={disabled}
        />
      </div>
      <div className='grid text-center'>
        <TimePeriodSelect
          // period={date!?.getHours() >= 12 ? 'PM' : 'AM'}
          disabled={disabled}
          period={dateToSec(date) > 43199 ? "PM" : "AM"}
          setPeriod={setPeriod}
          date={date}
          setDate={setDate}
          ref={periodRef}
        />
      </div>
      {showIcon && <CalendarIcon className='w-4 h-4 mr-2 ' />}
    </div>
  );
};
